import { Field, Form, Formik, FormikProps } from 'formik'
import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useSetRecoilState } from "recoil"
import apiService from "../services/api"
import { useLogger } from "../framework/logger"
import { ArrowLeftCircle as BackIcon } from '../svgicons/ArrowLeftCircle'
import { now } from "../framework/utils/date"
import { useTranslation } from 'react-i18next'
import { LivelloType, ServiceDescriptor, SezioneType } from "../models/ServiceDescriptor"
import { Autocomplete, AutocompleteChangeReason, Box, Button, TextField, Typography } from "@mui/material"
import { serviceRequestNumberState, useService } from '../atoms/serviceDescriptor'
import { useUser } from '../atoms'
import { GroupDescriptor } from '../models/GroupDescriptor'
import { useGroupDescriptors } from '../atoms/portale'
import { ambientiOptions, livelliOptions, OptionType, sdSezioniOptions, tipoApplOptions } from '../constants/index'
import { getSdValidationSchema } from '../validation/serviceDescriptor'
// import logConstants from '../utils/logConstants'

function ServiceEditPage() {
    const navigate = useNavigate();
    const user = useUser()
    const logger = useLogger({ key: 'service' });
    const {id } = useParams()
    const {service, resetService, fetchService } = useService()
    const { array: arrayGroups } = useGroupDescriptors()
    const { t } = useTranslation()
    const setServiceRequestNumberState = useSetRecoilState<number>(serviceRequestNumberState)
    const [provinceSel, setProvinceSel] = useState<OptionType[]>([])
    const [provinceEscludi, setProvinceEscludi] = useState<OptionType[]>([])

    // console.log('id', id);
    const handleBack = () => {
        resetService()
        navigate(-1);
    }
    const province: OptionType[] = user?.context?.province.map<OptionType>(x => ({ label: x.descrizione, value: x.descrizione })) ?? []
    // console.log('province', province)
    const getValueForAutocomplete = (myValue: number) => {
        let result = arrayGroups?.filter(x => x.id === myValue).map<OptionType>((x: GroupDescriptor) => ({value: x.id, label: x.label}));
        if (result && result.length > 0) return result[0]
        return undefined;
    }
    
    const defaultValue = (options: OptionType[], value: number | string) => {
        return options ? options.find(o => o.value === value) : null;
    }   
    const defaultValueSezione = (options: OptionType[], value: SezioneType) => {
        return options ? options.find(o => o.value === value) : null;
    } 
    const defaultValueLivello = (options: OptionType[], value: LivelloType) => {
        return options ? options.find(o => o.value === value) : null;
    }

    const setSelectProvince = (formik: FormikProps<ServiceDescriptor>, selectValue: OptionType[] | null) => {
        let value: string = ''
        // console.log('province selected', selectValue)
        if (selectValue && selectValue.length > 0) {
            selectValue.forEach(item => {
                value += item.label + ','
            })
        }
        // console.log('value of foreach', value)
        formik.setFieldValue('perProvince', value)
    }

    const setEscludiProvince = (formik: FormikProps<ServiceDescriptor>, selectValue: OptionType[] | null) => {
        let value: string = ''
        if (selectValue && selectValue.length > 0) {
            selectValue.forEach(item => {
                value += item.label + ','
            })
        }
        // console.log('value of foreach', value)
        formik.setFieldValue('escludiProvince', value)
    }
    
    useEffect(() => {
        //Get the data from Service descriptor
        if (id && id !== "0" && service && service.perProvince !== null) {
            let provinces: Array<string> = service.perProvince.split(',')
            // console.log('provinces', provinces)
            let provincesSelected: OptionType[] = []
            provinces.forEach(x => {
                if (x) {
                    let valuePerProvince: OptionType = {label: x, value: x}
                    provincesSelected = [...provincesSelected, valuePerProvince]                    
                }
            })
            // console.log('provincesSelected', provincesSelected)
            setProvinceSel(provincesSelected)
        }
        if (id && id !== '0' && service && service.escludiProvince !== null) {            
            let provinces: Array<string> = service.escludiProvince.split(',')
            let provincesEscludes: OptionType[] = []
            provinces.forEach(x => {
                if (x) {
                    let valuePerProvince: OptionType = {label: x, value: x}
                    provincesEscludes = [...provincesEscludes, valuePerProvince]                    
                }
            })
            setProvinceEscludi(provincesEscludes)
            // console.log('province escludes', provincesEscludes)
        }
    }, [id, service])
    
    useEffect(() => {
        if (service.id.toString() !== id) {
            // console.log(`%cDevo rileggere l'atomo ${id}`, logConstants.magenta10ptBold)
            if (id) {
                fetchService(parseInt(id))
            } else {
                resetService()
            }
        }
    }, [fetchService, id, service, resetService])

    console.log('service selected', service)
    return (
        <>
            <Box sx={{ display: 'flex', width: '100%', flexDirection: 'column' }} key={service.id}>
                <Box sx={{ display: 'flex', width: '100%', flexDirection: 'row', padding: '10px 0 0 13px' }}>
                    <Button onClick={handleBack} title={t('Indietro')}>
                        <BackIcon size={28} />
                    </Button>
                    <Typography variant="h3">{t('Gestione applicazione')}</Typography>
                </Box>
                <Box sx={{ display: 'flex', width: '100%', flexDirection: 'row' }}>
                    <Formik
                        initialValues={service}
                        validationSchema={getSdValidationSchema()}
                        onSubmit={(values, { setSubmitting }) => {
                            if (service?.id === 0) {
                                const insertService: ServiceDescriptor = {
                                    id: 0,
                                    userCre: user?.name,
                                    userUpd: user?.name,
                                    dateCre: now(),
                                    dateUpd: now(),
                                    groupDescriptorId: values.groupDescriptorId,
                                    livello: values.livello,
                                    sezione: values.sezione,
                                    tipoAppl: values.tipoAppl,
                                    tipologiaSito: values.tipologiaSito,
                                    ambiente: values.ambiente === '' ? null : values.ambiente,
                                    info: values.info,
                                    note: values.note,
                                    sorter: values.sorter!==null ? Number(values.sorter) : 1,
                                    url: values.url,
                                    urlDescription: values.urlDescription,
                                    datiApplicativo: values.datiApplicativo ? values.datiApplicativo : '', 
                                    serviceImageUrl: values.serviceImageUrl ? values.serviceImageUrl : '',
                                    serviceImageUrlDescription: values.serviceImageUrlDescription ? values.serviceImageUrlDescription : '',
                                    perProvince: values.perProvince,
                                    escludiProvince: values.escludiProvince,
                                    guid: values.guid === '' ? null : values.guid,
                                    enabled: true,
                                    fileEncoded: values.fileEncoded,
                                    disabilitato: values.disabilitato
                                } 
                                // console.log('updService', insertService)
                                apiService.saveServiceDesciptor(insertService).then(service => {
                                    setServiceRequestNumberState(p => p + 1)
                                    if (service) {
                                        // console.log('values post insert', values)                            
                                        values.id = service.id 
                                        // console.log('item added', service)
                                        //setAddLista(service)
                                        logger.info(`Service descriptor: ${service.urlDescription} aggiunto!`);
                                    } else {
                                        logger.error('Problemi nella creazione della news');
                                    }
                                }).catch(error => {
                                    console.error('Error in saving news');
                                    logger.error(error, 'error');
                                }).finally(() => {
                                    setSubmitting(false);
                                })
                            } else {
                                console.log('Update mode', values)
                                const updService = {
                                    ...values,
                                    userUpd: user?.name,
                                    dateUpd: now(),
                                    guid: values.guid === '' ? null : values.guid,
                                    ambiente: values.ambiente === '' ? null : values.ambiente
                                }
                                apiService.saveServiceDesciptor(updService).then(item => {
                                    setServiceRequestNumberState(p => p + 1)
                                    if (item) {
                                        // console.log('item updated', item)
                                        logger.info(`Service descriptor : ${item.urlDescription} aggiornato!`);
                                    } else {
                                        logger.error('Problemi nel salvataggio della news ');
                                    }
                                }).catch(error => {
                                    console.error('Error in saving Service descriptor');
                                    logger.error(error, 'error');
                                }).finally(() => {
                                    setSubmitting(false);
                                    //props.onSubmit && props.onSubmit();                            
                                })    
                            }
                        }
                    }
                    >
                        {(formik: FormikProps<ServiceDescriptor>) => {
                            const { values, setFieldValue, handleChange } = formik
                            return (
                                <Form style={{ width: '100%', padding: '10px 30px 10px 30px' }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                                        {/*<Box sx={{ marginBottom: '20px', display: 'flex', flexDirection: 'column' }}>
                                            <label htmlFor="id"><b>{t('Id')}</b></label>
                                            <TextField id="id" name="id" value={values.id} type="text" disabled size='small' />
                                            {formik.touched.id && formik.errors.id ? (
                                                <Box>{formik.errors.id}</Box>
                                            ) :
                                            null}
                                        </Box>
                                        */}
                                        <Box sx={{ marginBottom: '20px', display: 'flex', flexDirection: 'column', width: '80%' }}>
                                            <label htmlFor="url"><b>Url</b></label>
                                            <TextField id="url" name="url" type="text" fullWidth size='small' onChange={handleChange} value={values.url}/>
                                            
                                            {formik.touched.url && formik.errors.url ? (
                                                <Box sx={{ color: 'red' }}>{formik.errors.url}</Box>
                                            ) : null}
                                        </Box>
                                        <Box sx={{ marginBottom: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <label htmlFor="enabled"><b>{t('Autorizzato')}</b></label>
                                            <Box sx={{py: 1}}>
                                                <Field
                                                    name="enabled"
                                                    type="checkbox"
                                                    readOnly
                                                    disabled
                                                />
                                            </Box>
                                        </Box>
                                        <Box sx={{ marginBottom: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <label htmlFor="disabilitato"><b>{'Eliminato'}</b></label>
                                            <Box sx={{py: 1}}>
                                                <Field
                                                    name="disabilitato"
                                                    type="checkbox"
                                                    checked={values.disabilitato}
                                                />
                                            </Box>
                                        </Box>
                                    </Box>
                                    <label htmlFor="groupDescriptorId"><b>{t('Gruppo di competenza')}</b></label>
                                    <Box style={{ marginBottom: '20px' }}>
                                        <Autocomplete
                                            id="groupDescriptorId"
                                            filterSelectedOptions
                                            options={arrayGroups?.map<OptionType>(x => ({ value: x.id, label: x.label})) ?? []}
                                            value={getValueForAutocomplete(values.groupDescriptorId)}
                                            onChange={(event: React.SyntheticEvent<Element, Event>, value: OptionType | null, reason: AutocompleteChangeReason) => {
                                                //const result = value ? value.reduce((p, x) => `${p}${x.area};`, '') : ''
                                                //console.log('result for aree', result?.toString().replace(',', ''))
                                                setFieldValue("groupDescriptorId", value?.value);
                                            }}
                                            renderInput={params => (
                                                <TextField
                                                    {...params}
                                                    name="groupDescriptorId"
                                                    variant="outlined"
                                                    fullWidth
                                                    size='small'
                                                />
                                            )}
                                        />
                                        {formik.errors.groupDescriptorId ? (
                                            <Box sx={{ color: 'red' }}>{formik.errors.groupDescriptorId}</Box>
                                        )
                                            : null}
                                    </Box>
                                    <label htmlFor="urlDescription"><b>{t('Descrizione Url')}</b></label>
                                    <Box style={{ marginBottom: '20px' }}>
                                        <TextField
                                            id="urlDescription"
                                            name="urlDescription"
                                            type="text"
                                            value={values.urlDescription}
                                            fullWidth
                                            onChange={handleChange}
                                            size='small'
                                        />
                                        {formik.touched.urlDescription && formik.errors.urlDescription ? (
                                            <Box sx={{ color: 'red' }}>{formik.errors.urlDescription}</Box>
                                        )
                                            : null}
                                    </Box>
                                    <Box style={{ marginBottom: '20px' }}>
                                        <label htmlFor="note"><b>{t('Note')}</b></label>
                                        <TextField name="note" fullWidth type="text" size='small' onChange={handleChange} value={values.note}/>
                                        
                                        {formik.touched.note && formik.errors.note ? (
                                            <Box sx={{ color: 'red' }}>{formik.errors.note}</Box>
                                        ) : null}
                                    </Box>
                                    <Box style={{ marginBottom: '20px' }}>
                                        <label htmlFor="livello"><b>Livello</b></label>
                                        <Autocomplete 
                                            id="livello" 
                                            options={livelliOptions} 
                                            value={defaultValueLivello(livelliOptions, values.livello)}
                                            //onChange={(value: OptionType) => formik.setFieldValue('groupDescriptorId', value)} 
                                            onChange={(event: React.SyntheticEvent<Element, Event>, value: OptionType | null, reason: AutocompleteChangeReason) => {
                                                //const result = value ? value.reduce((p, x) => `${p}${x.area};`, '') : ''
                                                //console.log('result for aree', result?.toString().replace(',', ''))
                                                setFieldValue("livello", value?.value);
                                            }}
                                            renderInput={params => (
                                                <TextField
                                                    {...params}
                                                    name="livello"
                                                    variant="outlined"
                                                    fullWidth
                                                    size='small'
                                                />
                                            )}
                                        />                                        
                                        {formik.touched.livello && formik.errors.livello ? (
                                            <Box sx={{ color: 'red' }}>{formik.errors.livello}</Box>
                                        ) : null}
                                    </Box>
                                    <Box sx={{ marginBottom: '20px' }}>
                                        <label htmlFor="sezione"><b>Sezione</b></label>
                                        <Autocomplete 
                                            id="sezione" 
                                            options={sdSezioniOptions} 
                                            value={defaultValueSezione(sdSezioniOptions, values.sezione)}
                                            onChange={(event: React.SyntheticEvent<Element, Event>, value: OptionType | null, reason: AutocompleteChangeReason) => {
                                                //console.log('result for aree', result?.toString().replace(',', ''))
                                                setFieldValue("sezione", value?.value);
                                            }}
                                            renderInput={params => (
                                                <TextField
                                                    {...params}
                                                    name="sezione"
                                                    variant="outlined"
                                                    fullWidth
                                                    size='small'
                                                />
                                            )}
                                        />
                                        {formik.touched.sezione && formik.errors.sezione ? (
                                            <Box sx={{ color: 'red' }}>{formik.errors.sezione}</Box>
                                        ) : null}
                                    </Box>
                            
                                    <Box sx={{ marginBottom: '20px' }}>
                                        <label htmlFor="tipoAppl"><b>Tipo applicazione</b></label>
                                        <Autocomplete 
                                            id="tipoAppl" 
                                            options={tipoApplOptions} 
                                            value={defaultValue(tipoApplOptions, values.tipoAppl)}
                                            //value={formik.values.groupDescriptorId}                                    
                                            //onChange={(value: OptionType) => formik.setFieldValue('groupDescriptorId', value)} 
                                            onChange={(event: React.SyntheticEvent<Element, Event>, value: OptionType | null, reason: AutocompleteChangeReason) => {
                                                //Servono entrambi i comandi, per quello che vedo a video e per il valore di Formik che passo ai dati
                                                formik.setFieldValue('tipoAppl', value?.value)
                                                // if (value)
                                                //     setServiceD({...serviceD, tipoAppl: value.value as string})
                                            }}
                                            renderInput={params => (
                                                <TextField
                                                    {...params}
                                                    name="tipoAppl"
                                                    variant="outlined"
                                                    fullWidth
                                                    size='small'
                                                />
                                            )}
                                        />                                        
                                        {formik.errors.tipoAppl ? (
                                            <Box sx={{ color: 'red' }}>{formik.errors.tipoAppl}</Box>
                                        ) : null}
                                    </Box>
                            
                                    <Box sx={{ marginBottom: '20px' }}>
                                        <label htmlFor="tipoologiaSito"><b>Tipologia sito</b></label>
                                        <TextField name="tipologiaSito" type="text" size='small' fullWidth onChange={handleChange} value={values.tipologiaSito}/>
                                        
                                        {formik.touched.tipologiaSito && formik.errors.tipologiaSito ? (
                                            <Box sx={{color: 'red'}}>{formik.errors.tipologiaSito}</Box>
                                        ) : null}
                                    </Box>
                            
                                    <Box sx={{ marginBottom: '20px' }}>
                                        <label htmlFor="guid"><b>Guid</b></label>
                                        <TextField name="guid" type="text" size='small' fullWidth onChange={handleChange} value={values.guid}/>
                                        
                                        {formik.touched.guid && formik.errors.guid ? (
                                            <Box sx={{color: 'red'}}>{formik.errors.guid}</Box>
                                        ) : null}
                                    </Box>
                            
                                    <Box sx={{ marginBottom: '20px' }}>
                                        <label htmlFor="ambiente"><b>Ambiente</b></label>
                                        <Autocomplete 
                                            id="ambiente" 
                                            options={ambientiOptions} 
                                            value={defaultValue(ambientiOptions, values.ambiente as string)}
                                            //value={formik.values.groupDescriptorId}                                    
                                            //onChange={(value: OptionType) => formik.setFieldValue('groupDescriptorId', value)} 
                                            onChange={(event: React.SyntheticEvent<Element, Event>, value: OptionType | null, reason: AutocompleteChangeReason) => {
                                                //Servono entrambi i comandi, per quello che vedo a video e per il valore di Formik che passo ai dati  
                                                console.log('value set ambiente', value)
                                                formik.setFieldValue('ambiente', value?.value)
                                                // if (value)
                                                //     setServiceD({...serviceD, tipoAppl: value.value as string})
                                            }}
                                            renderInput={params => (
                                                <TextField
                                                    {...params}
                                                    name="ambiente"
                                                    variant="outlined"
                                                    fullWidth
                                                    size='small'
                                                />
                                            )}
                                        />                                        
                                    </Box>
                            
                                    <Box sx={{ marginBottom: '20px' }}>
                                        <label htmlFor="datiApplicativo"><b>Dati applicativo</b></label>
                                        <TextField name="datiApplicativo" type="text" size='small' fullWidth onChange={handleChange} value={values.datiApplicativo}/>
                                        
                                        {formik.touched.datiApplicativo && formik.errors.datiApplicativo ? (
                                            <Box sx={{color: 'red'}}>{formik.errors.datiApplicativo}</Box>
                                        ) : null}
                                    </Box>
                                    {/*
                                    <label htmlFor="serviceImageUrl"><b>Immagine del servizio </b></label>
                                    <Box className={classes.root}>
                                        <Box sx={{display: 'flex', gap: 1, width: '100%'}}>
                                            {!values.serviceImageUrl ? 
                                                <UploadComponent setFieldValue={setFieldValue} submitForm={submitForm}/>                                        
                                            :
                                                displayControl(values.serviceImageUrl, handleDelete)
                                            }
                                            <TextField sx={{pt: 2, width: '100%'}} name="serviceImageUrl" type="text" size='small' fullWidth onChange={handleChange} value={values.serviceImageUrl}/>
                                        </Box>
                                    </Box>
                                    <Confirm
                                        open={isDeleteDialogOpen}
                                        onCancel={() => setIsDeleteDialogOpen(false)}
                                        onConfirm={() => {
                                            setFieldValue("serviceImageUrl", '')
                                            setFieldValue("fileEncoded", '')
                                            console.log('file encoded null, image url null')
                                            //setServiceRequestNumberState(p => p + 1)
                                            setIsDeleteDialogOpen(false);
                                        }}
                                    />
                                    <Box sx={{ marginBottom: '20px' }}>
                                        <label htmlFor="serviceImageUrlDescription"><b>Descrizione Immagine del servizio</b></label>
                                        <TextField name="serviceImageUrlDescription" fullWidth onChange={handleChange} value={values.serviceImageUrlDescription} type="text" size='small' />
                                        
                                        {formik.touched.serviceImageUrlDescription && formik.errors.serviceImageUrlDescription ? (
                                            <div>{formik.errors.serviceImageUrlDescription}</div>
                                        ) : null}
                                    </Box>
                                    */}
                                    <Box sx={{  marginBottom: '20px' }}>
                                        <label htmlFor="perProvince"><b>Includi Province</b></label>
                                        <Box>
                                            <Autocomplete
                                                id="perProvince" 
                                                multiple={true} 
                                                filterSelectedOptions
                                                options={province} 
                                                value={provinceSel}
                                                onChange={(event: React.SyntheticEvent<Element, Event>, value: OptionType[] | null, reason: AutocompleteChangeReason) => {
                                                    //const result = value ? value.reduce((p, x) => `${p}${x.value};`, '') : ''
                                                    // console.log('onchange for province', value)
                                                    //the first to refresh the values at the video
                                                    setProvinceSel(value ?? [])
                                                    setSelectProvince(formik, value)
                                                }}
                                                renderInput={params => (
                                                    <TextField
                                                        {...params}
                                                        name="perProvince"
                                                        variant="outlined"
                                                        fullWidth
                                                        size='small'
                                                    />
                                                )}
                                                style={{width: '100%'}}
                                            />
                                        </Box>
                                    </Box>
                                    {/* <Box sx={{ display: 'flex', marginBottom: '20px' }}>
                                        <label htmlFor="province"><b>Province</b></label>
                                        <Box>
                                            <Autocomplete
                                                id="province" 
                                                multiple={true} 
                                                filterSelectedOptions
                                                options={province} 
                                                value={provinceSel}
                                                onChange={(event: React.SyntheticEvent<Element, Event>, value: OptionType[] | null, reason: AutocompleteChangeReason) => {
                                                    //the first to refresh the values at the video
                                                    setProvinceSel(value ?? [])
                                                    setSelectProvince(formik, value)
                                                }}
                                                renderInput={params => (
                                                    <TextField
                                                        {...params}
                                                        name="province"
                                                        variant="outlined"
                                                        fullWidth
                                                        size='small'
                                                    />
                                                )}
                                                style={{width: '100%', display: 'flex'}}
                                            />
                                        </Box>
                                    </Box>                             */}
                                    <Box sx={{ marginBottom: '20px' }}>
                                        <label htmlFor="esludiProvince"><b>Escludi Province</b></label>
                                        <Box>
                                            <Autocomplete
                                                multiple={true} 
                                                id="esludiProvince" 
                                                filterSelectedOptions
                                                options={province} 
                                                value={provinceEscludi}
                                                onChange={(event: React.SyntheticEvent<Element, Event>, value: OptionType[] | null, reason: AutocompleteChangeReason) => {
                                                    //The first for the video
                                                    setProvinceEscludi(value ?? [])
                                                    //The second to update the DB
                                                    setEscludiProvince(formik, value)
                                                }}
                                                renderInput={params => (
                                                    <TextField
                                                        {...params}
                                                        name="esludiProvince"
                                                        variant="outlined"
                                                        fullWidth
                                                        size='small'
                                                    />
                                                )}
                                            />
                                        </Box>
                                    </Box>
                                    <Box sx={{ marginBottom: '20px' }}>
                                        <label htmlFor="content"><b>Info</b></label>
                                        <TextField 
                                            name="info" 
                                            type="text" 
                                            multiline
                                            maxRows={5}
                                            rows={3}
                                            fullWidth 
                                            onChange={handleChange} 
                                            value={values.info}
                                        />
                                    </Box>
                                    <Box sx={{ mt: 1 }}>
                                        <Button type="submit" disabled={formik.isSubmitting} title={t('Salva')} variant="outlined">
                                            {formik.isSubmitting ? "Attendere..." : ""}
                                            Salva
                                        </Button>
                                    </Box>
                                </Form>
                            )
                        }}
                    </Formik>
                </Box>
            </Box>
        </>
    )
}

export default ServiceEditPage
